import { Component, Input, OnInit } from '@angular/core';
import { BaseImagePlaceholderEnum, BaseAvatarSize, CommentResponse, WorkCouncilStatus } from 'base';
import { BaseCustomerWorkCouncilStatusEnum } from '../../../_enums/base-customer-work-council-status.enum';

@Component({
  selector: 'base-customer-work-council-comment',
  templateUrl: './base-customer-work-council-comment.component.html',
})
export class BaseCustomerWorkCouncilCommentComponent implements OnInit {
  @Input() comment: CommentResponse;

  avatarSrc: string = BaseImagePlaceholderEnum.BASE_DEFAULT_AUTO_AVATAR;
  statusData = {
    name: '',
    color: '',
  };
  avatarSize = BaseAvatarSize;

  ngOnInit() {
    this.statusData = this.getApproveStatus(this.comment.type);
    this.avatarSrc = this.getAvatar(this.comment);
  }

  getApproveStatus(status?: WorkCouncilStatus) {
    switch (status) {
      case BaseCustomerWorkCouncilStatusEnum.AUTO_APPROVED:
        return {
          name: 'workCouncil.status.autoApprove',
          color: 'success',
        };
      case BaseCustomerWorkCouncilStatusEnum.APPROVED:
        return {
          name: 'workCouncil.status.approve',
          color: 'success',
        };
      case BaseCustomerWorkCouncilStatusEnum.DISAPPROVED:
        return {
          name: 'workCouncil.status.disapprove',
          color: 'danger',
        };
      case BaseCustomerWorkCouncilStatusEnum.NOTED:
        return {
          name: 'workCouncil.status.note',
          color: 'success',
        };
      default:
        return {
          name: '',
          color: '',
        };
    }
  }

  getAvatar(comment: CommentResponse) {
    if (comment.type === BaseCustomerWorkCouncilStatusEnum.AUTO_APPROVED) {
      return BaseImagePlaceholderEnum.BASE_DEFAULT_AUTO_AVATAR;
    }

    return comment.avatar || BaseImagePlaceholderEnum.BASE_DEFAULT_AVATAR;
  }
}
